import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type Card = {
  card_id?: number; // 카드 idx
  user_id?: number; // 유저 idx
  card_number?: string; // 카드번호
  card_validity?: string; // 카드 유효기간
  cvc?: string; // CVC 번호
  card_password?: string; // 카드 비밀번호 앞2자리
  card_company?: string; // 카드사
  information_provision?: string; // 개인정보제공동의
  payment_password?: string; // 결제비밀번호
  type?: string; // 타입(정기결제, 렌탈)
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Card
   * --
   */
  getCards: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_CARD, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Card
   * --
   */
  getCard: async (idx: number, params?: { [key: string]: string | number }) => {
    try {
      const url = parameterToPath(APIConstant.GET_CARD, { card_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Card
   * --
   */
  createCard: async (body: Card) => {
    try {
      const res = await $http.post(APIConstant.CREATE_CARD, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Card
   * --
   */
  updateCard: async (body: Card) => {
    try {
      const { card_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_CARD, {
        card_id: card_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Card
   * --
   */
  deleteCard: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_CARD, {
        card_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
